import { PaymentSecurityScreens } from '../typings';
const shouldShowCrossBorderModal = (securityScreen) => {
    const screensWithModal = [
        PaymentSecurityScreens.ENROLLED,
        PaymentSecurityScreens.CANCELLED
    ];
    return screensWithModal.includes(securityScreen);
};
export default shouldShowCrossBorderModal;
